import React from 'react'

function Entrepreneurship() {
  return (
    <div>Entrepreneurship</div>
  )
}

export default Entrepreneurship